import { Expose } from 'class-transformer';

export class MailTokenEntity {
  @Expose()
  accessToken: string;

  @Expose()
  expiresAt: Date;
}
